import React, { Component } from "react";
import { Grid, Row, Col, Table } from "react-bootstrap";
import Card from "../../components/Card/Card.jsx";
import { NavLink } from "react-router-dom";
import gql from "graphql-tag";

import { ApolloClient } from 'apollo-client';
import { Query } from "react-apollo";
import { InMemoryCache } from 'apollo-cache-inmemory';
import { HttpLink } from 'apollo-link-http';

import Select from 'react-select';
import { FormInputs } from "../../components/FormInputs/FormInputs.jsx";
import Button from "../../components/CustomButton/CustomButton.jsx";


const restLink_cloud = new HttpLink({ 
  uri: "/api/v1/cloud/",
  credentials: 'include'  
});
const account_cloud = new ApolloClient({
  link: restLink_cloud,
  cache: new InMemoryCache(),
});

const CREATE_CLUSTER_HAS_FLAVOR = gql`
  mutation createClusterHasFlavor($cluster_id: Int!, $flavor_id: Int!){
    createClusterHasFlavor(cluster_id:$cluster_id, flavor_id: $flavor_id) {
      id
    }
  }
`;

const DELETE_CLUSTER_HAS_FLAVOR = gql`
mutation deleteClusterHasFlavor($cluster_id: Int!, $flavor_id: Int!){
  deleteClusterHasFlavor(cluster_id:$cluster_id, flavor_id: $flavor_id) {
    id
  }
}
`;
const GET_CLUSTER_HAS_FLAVOR = gql`
  query clusterHasFlavor_collection($flavor_id: Int!){
    clusterHasFlavor_collection(flavor_id: $flavor_id) {
      ClusterHasFlavor{
        id
        cluster{
          value:id
          label:title
        }
      }
    }
  }
`;


const GET_CLUSTER = gql`
{
  cluster_collection{
    clusters{
      value:id
      label:title
    }
  }
}
`;




class ClusterHasFlavor extends Component {

  controllerItens = [];
  urlBack;

  constructor() {
    super();
     this.state = {
       defaultOptions : [],
    }

  }

  
  onChange = (inputValue, action ) => {
    
    // Adicionar
    if(action.action === 'select-option') {
      account_cloud.mutate({
        mutation: CREATE_CLUSTER_HAS_FLAVOR,
        variables: {
          cluster_id: action.option.value, flavor_id: parseInt(this.props.match.params.id)
        }
      });
    } 
    // Remover
    else if(action.action === 'remove-value') {
      
      account_cloud.mutate({
        mutation: DELETE_CLUSTER_HAS_FLAVOR,
        variables: {
          cluster_id: action.removedValue.value, flavor_id: parseInt(this.props.match.params.id)
        }
      });
    }
 
  } 

  onInputChange = (inputValue, action ) => {

    console.log("------- CREATE");
    console.log(inputValue);
    
    /*
    account_cloud.mutate({
      mutation: CREATE_CLUSTER_HAS_FLAVOR,
      variables: {
        account_module_id: inputValue, profile_id: this.props.match.params.id
      }
    });
    */
    
  }


  handleSubmit = (event) => {
    event.preventDefault();
    

  }

  render() {
    
    
    return (

      <div className="content">
        <Grid fluid>
          <Row>
            <Col md={12}>
              <a
                  href='javascript:history.go(-1)'
                  className="btn btn-info btn-fill"
                >
                VOLTAR
              </a>

              <Card
                title={"Clusters"}
                category=""
                ctTableFullWidth
                ctTableResponsive
                content={

                  <form 
                  onSubmit={e => {
                    this.handleSubmit(e);
                    e.preventDefault();
                  }}
                  >
                  
                  <Table striped hover>
                    <thead>
                      <tr>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>

                    <Query
                        client={account_cloud}
                        query={GET_CLUSTER}
                      >
                        {({ loading, error, data }) => {

                          if (loading) return <tr><td>Carregando...</td></tr>;
                          if (error) return <tr><td>Erro :( x</td></tr>;

                                var select_options = data.cluster_collection.clusters;
                               
                                return (
                        
                                <Query
                                  client={account_cloud}
                                  variables={{flavor_id:this.props.match.params.id}}
                                  query={GET_CLUSTER_HAS_FLAVOR}
                                >
                                  {({ loading, error, data }) => {

                                    if (loading) return <tr><td>Carregando...</td></tr>;
                                    if (error) return <tr><td>Erro :(</td></tr>;

                                      var defaultValues = [];
                                      data.clusterHasFlavor_collection.ClusterHasFlavor.map((ClusterHasFlavor) => {
                                        var ClusterHasFlavor = ClusterHasFlavor.cluster;
                                        defaultValues.push(ClusterHasFlavor); 
                                      });
                                      return (
                                          <tr>
                                            <td>
                                              <Select
                                                    defaultValue={this.state.defaultValue && this.state.defaultValue ? this.state.defaultValue : defaultValues}
                                                    isMulti
                                                    isSearchable
                                                    name={"values"}
                                                    options={select_options}
                                                    className="basic-multi-select"
                                                    classNamePrefix="select"
                                                    //inputValue={inputValue}
                                                    onChange={this.onChange}
                                                    //onInputChange={this.onInputChange}
                                                    isClearable={false}
                                                  />
                                            </td>
                                          </tr>
                                      );
                                  }}
                                </Query>
                                );
                              }}
                            </Query>
                          
                        <tr>
                          <td>
                          <Button bsStyle="info" pullRight fill onClick={() => {window.location.reload()}}>
                            Salvar
                          </Button>
                          </td>
                          <td></td>
                        </tr>
                    </tbody>
                  </Table>
                  

                  </form>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default ClusterHasFlavor;
